import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  semiBold: {
    fontWeight: 600,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    '& .MuiPaper-root': {
      elevation: 3,
    },
    maxWidth: '100%',
  },
  title: {
    marginLeft: '0px',
    marginBottom: '0px',
    marginTop: '1rem',
    paddingLeft: '0px',
  },
  loading: {
    color: theme.palette.primary.main,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100px',
  },
  generalView: {
    backgroundColor: theme.palette.custom.cardBackground,
    borderRadius: '10px',
    marginBottom: '10px',
    minHeight: '100px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    // NOTE: this block previously declared `backgroundColor: '000'` — a malformed
    // value (missing '#') that the browser discarded, so it never rendered.
    // Removed rather than translated, to keep the current appearance.

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },

  },
  filterField: {
    width: '300px',
    flex: '0 0 auto',
    flexGrow: '0 !important',
    textAlign: 'left',
  },
}));

export default useStyles;
